import LOGO_DARK from './diy-logo-dark.png';

const media = {
  LOGO_DARK,
};

export default media;
